import { ICountry } from '../../models/country'
import {
  IClearVerificationFieldsAction,
  IConfirmVerificationCodeAction,
  IConfirmVerificationCodeFailedAction,
  IConfirmVerificationCodeSuccessfulAction,
  IResendVerificationCodeAction,
  IResendVerificationCodeFailedfulAction,
  IResendVerificationCodeSuccessfulAction,
  ISetIsConfirmingVerificationCodeAction,
  ISetIsResendingVerificationCodeAction,
  ISetVerificationCallingCodeAction,
  ISetVerificationCodeAction,
  ISetVerificationCountryAction,
  ISetVerificationDNIAction,
  ISetVerificationEmailAction,
  ISetVerificationOriginAction,
  ISetVerificationPhoneAction,
  VerificationOrigin,
  VerificationTypeKeys
} from '../types'

export function clearVerificationFieldsAction(): IClearVerificationFieldsAction {
  return { type: VerificationTypeKeys.CLEAR_VERIFICATION_FIELDS }
}

export function setVerificationDNIAction(email: string): ISetVerificationDNIAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_DNI, payload: email }
}

export function setVerificationCodeAction(code: string): ISetVerificationCodeAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_CODE, payload: code }
}

export function confirmVerificationCodeAction(): IConfirmVerificationCodeAction {
  return { type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE }
}

export function setIsConfirmingVerificationCodeAction(): ISetIsConfirmingVerificationCodeAction {
  return { type: VerificationTypeKeys.CONFIRMING_VERIFICATION_CODE }
}

export function confirmVerificationCodeSuccessfulAction(): IConfirmVerificationCodeSuccessfulAction {
  return { type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE_SUCCESSFUL }
}

export function confirmVerificationCodeFailedAction(): IConfirmVerificationCodeFailedAction {
  return { type: VerificationTypeKeys.CONFIRM_VERIFICATION_CODE_FAILED }
}

export function setVerificationEmailAction(email: string): ISetVerificationEmailAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_EMAIL, payload: email }
}

export function setVerificationPhoneAction(phone: string): ISetVerificationPhoneAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_PHONE, payload: phone }
}

export function setVerificationCallingCodeAction(callingCode: string): ISetVerificationCallingCodeAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_CALLING_CODE, payload: callingCode }
}

export function setVerificationCountryAction(country: ICountry): ISetVerificationCountryAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_COUNTRY, payload: country }
}

export function resendVerificationCodeAction(): IResendVerificationCodeAction {
  return { type: VerificationTypeKeys.RESEND_VERIFICATION_CODE }
}

export function setIsResendingVerificationCodeAction(): ISetIsResendingVerificationCodeAction {
  return { type: VerificationTypeKeys.RESENDING_VERIFICATION_CODE }
}

export function resendVerificationCodeSuccessfulAction(): IResendVerificationCodeSuccessfulAction {
  return { type: VerificationTypeKeys.RESEND_VERIFICATION_CODE_SUCCESSFUL }
}

export function resendVerificationCodeFailedAction(): IResendVerificationCodeFailedfulAction {
  return { type: VerificationTypeKeys.RESEND_VERIFICATION_CODE_FAILED }
}

export function setVerificationOriginAction(origin: VerificationOrigin | null): ISetVerificationOriginAction {
  return { type: VerificationTypeKeys.SET_VERIFICATION_ORIGIN, payload: origin }
}
